import _reduxForm from "redux-form/es/reduxForm";
import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import { ReduxFormNames } from 'swag-client-common/constants';
import { capitalize } from 'swag-common/utils/strings';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import { UnderlinedPasswordInput } from 'swag-client-common/components/inputs/password-input';
import PasswordRequirementsBlock from 'swag-client-common/components/info/password-requirements-block';
import { required, password as passwordValidator } from 'swag-client-common/utils/redux-form-validators';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import classes from './invitation-form.scss';
function InvitationForm(props) {
  const {
    name,
    errorMessage,
    handleSubmit,
    onSubmit,
    isError,
    isLoading,
    inventoryName,
    password,
    completedPasswordRequirements,
    isAllPasswordRequirementsCompleted,
    isPasswordLengthMoreThanMaxAllowedCharacters,
    isPasswordInputFocused,
    invalid
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("h2", {
    className: classnames(utilClasses.textCenter, classes.notificationHeader)
  }, "Hi ", /*#__PURE__*/React.createElement("span", {
    className: classes.blue
  }, name), "! You have been invited to the", ' ', /*#__PURE__*/React.createElement("span", {
    className: classes.blue
  }, capitalize(inventoryName)), " closet! Create an account to proceed."), /*#__PURE__*/React.createElement("form", {
    className: utilClasses.textCenter,
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(_Field, {
    name: "password",
    component: UnderlinedPasswordInput,
    isAllPasswordRequirementsCompleted: isAllPasswordRequirementsCompleted,
    type: "password",
    validate: [required, passwordValidator],
    label: "Create password",
    errorClassName: password ? classes.strengthInputErrorClassName : classes.errorClassName
  }), /*#__PURE__*/React.createElement(PasswordRequirementsBlock, {
    isLengthMoreThanMaxAllowedCharacters: isPasswordLengthMoreThanMaxAllowedCharacters,
    completedRequirements: completedPasswordRequirements,
    isAllRequirementsCompleted: isAllPasswordRequirementsCompleted,
    isInputFocused: isPasswordInputFocused,
    className: classes.requirementsListMobile
  }), isError && /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, errorMessage), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    size: "small",
    loading: isLoading,
    className: classes.submitButton,
    disabled: invalid,
    textTransform: ButtonTextTransform.none
  }, "Submit")));
}
export default _reduxForm({
  form: ReduxFormNames.InvitationForm
})(InvitationForm);